import { render, staticRenderFns } from "./InsightsTicker.vue?vue&type=template&id=233f6571&scoped=true&"
import script from "./InsightsTicker.vue?vue&type=script&lang=js&"
export * from "./InsightsTicker.vue?vue&type=script&lang=js&"
import style0 from "./InsightsTicker.vue?vue&type=style&index=0&id=233f6571&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233f6571",
  null
  
)

export default component.exports